module.exports = __webpack_public_path__ + "static/media/polytechnic-campus.150140eb.webp";